import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { http, errText } from "@/lib/api";
import { money } from "./usePrices";
import { PayPalPay } from "./PayPalPay";

export const PayPalCheckout = ({ bookingId, amount, label }) => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    http.get("/paypal/config").then((r) => setCfg(r.data ?? { enabled: false })).catch(() => setCfg({ enabled: false }));
  }, []);
  if (!cfg) return null;
  if (!cfg.enabled || !cfg.client_id) return <PayPalPay amount={amount} label={label} />;
  return (
    <div data-testid="paypal-checkout-panel" className="mt-8 rounded-[24px] border border-[#E6E0D4] bg-[#F4F0E8] p-6 text-left">
      <p className="text-xs uppercase tracking-[0.25em] text-[#A8613C] font-semibold">Complete your payment</p>
      <p className="mt-3 mb-5 text-sm text-[#5E584F]">
        <span data-testid="paypal-amount" className="font-display text-2xl text-[#2D2A26]">{amount ? money(amount) : ""} USD</span> for your {label}
      </p>
      <PayPalScriptProvider options={{ clientId: cfg.client_id, currency: "USD", intent: "capture", enableFunding: "venmo" }}>
        <PayPalButtons
          style={{ layout: "vertical", shape: "pill", color: "gold", label: "pay" }}
          createOrder={async () => (await http.post("/paypal/orders", { booking_id: bookingId })).data.id}
          onApprove={async (data) => {
            try {
              await http.post(`/paypal/orders/${data.orderID}/capture`, { booking_id: bookingId });
              window.location.assign("/thank-you");
            } catch (e) { toast.error(errText(e)); }
          }}
          onError={() => toast.error("PayPal couldn't complete the payment. Please try again.")}
        />
      </PayPalScriptProvider>
    </div>
  );
};
